import { ReactNode } from 'react';

interface MobileCardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function MobileCard({ children, className = '', onClick }: MobileCardProps) {
  return (
    <div
      className={`bg-white rounded-2xl shadow-[0_2px_8px_rgba(0,0,0,0.04)] border border-gray-100 p-4 mb-3 ${
        onClick ? 'cursor-pointer hover:shadow-md hover:border-blue-100 transition-all duration-300 active:scale-[0.97]' : ''
      } ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}


